export default __webpack_public_path__ + "static/media/PointDefectsImg.438f39de.jpg";